<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Manufacture">
    <template v-slot:body>
      <TableList :config="config()"></TableList>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import TableList from './TableList.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    TableList
  },
  methods: {
    config() {
      return {
        showTableFilters: true,
        preload: true,
        tableId: 'manufacture',
        indexUri: 'manufacture',
        storeId: ['main']
      }
    },
    addNewModal() {
      this.$emitter.emit('Modal', {
        name: 'manufacture.create',
        data: {},
        $el: null
      })
    }
  }
}
</script>
<style lang="scss">
.modal.edit-manufacture-form {
  .modal-dialog {
    padding: 0;
    margin: 0;
    width: 100% !important;
    max-width: 100% !important;
    height: 100%;
    overflow: hidden;
  }
  .modal-header,
  .modal-footer {
    display: none !important;
  }
  .manufacture-details.edit {
    .notes {
      margin: 0;
      padding: 0;
      list-style: none;
      textarea {
        margin: 0;
      }
    }
  }
  .modal-content,
  .modal-body,
  .body-container,
  .popup-wrap,
  .thumbnail {
    width: 100%;
    height: 100%;
  }

  .modal-content {
    border: 0;
    border-radius: 0 !important;
    background-color: transparent;
  }
  .modal-body {
    padding: 0 !important;
  }
  .popup-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .main-thumbnail {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &:after {
      content: '';
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.7;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      z-index: 1;
      object-fit: contain;
      &.cover {
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        filter: blur(8px);
      }
    }
  }

  .edit-status {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > * {
      margin-right: 10px !important;
      &:last-child {
        margin-right: 0 !important;
      }
    }
    .form-control {
      height: auto;
    }
    a {
      text-decoration: none !important;
    }

    .list-line-item {
      width: 100%;
      position: relative;
      .checkmark {
        width: 100%;
        position: relative;
        height: auto;
        background: 0;
        border-left: 5px solid transparent;
        padding: 10px;
        margin: 15px 0;
        border: 1px solid #eee;
        border-radius: var(--border-radius, 0.25rem);
        overflow: hidden;
      }
      .thumbnail {
        max-width: 100px;
        max-height: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      .item-meta {
        margin-left: 20px;
        .title {
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
      .attributes {
        padding-left: 18px;
        line-height: 1;
        li {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          label {
            text-transform: capitalize;
            margin-right: 10px;
            margin-bottom: 0;
          }
          span {
            line-height: 1.4;
          }
        }
      }
    }
  }

  .manufacture-details {
    width: 100%;
    .details {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      h2 {
        width: 100%;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 0;
      }
      > span {
        font-size: 12px;
        padding: 0;
      }
      .date-modified {
        color: #8a8a8a;
      }
    }
    input,
    select {
      &.form-control {
        margin: 0;
        font-size: 14px;
      }
    }
    .attribute {
      .notes {
        li {
          white-space: pre-line;
        }
      }
    }
  }

  .main-container {
    width: 450px;
    background: #fff;
    overflow: auto;
    height: 100%;
    z-index: 1;
    .form-group {
      margin: 0.5rem 0;
      > label {
        display: inline;
        font-weight: bold;
        font-size: 14px;
        color: #555;
      }
    }
    hr {
      border-color: #dfdfdf;
      width: calc(100% - 30px);
      margin: 0 15px;
    }
    .description {
      label {
        display: inline;
        font-weight: bold;
        font-size: 14px;
        color: #555;
      }
    }
    .attribute {
      input[disabled] {
        background: 0;
        border: 0;
        padding: 0;
        margin: 0;
        height: auto;
        display: inline;
        width: auto;
        font-size: 14px;
      }
    }
    .chat-inner {
      list-style: none;
      padding: 0;
      margin-top: 15px;
      > :last-child {
        margin-bottom: 0;
      }
    }
    .chat-box-container {
      display: flex;
      margin-bottom: 15px;
      &.topic {
        .date-created-wrapper,
        .avatar-icon-wrapper,
        .user-wrapper,
        .reply {
          display: none !important;
        }
        .chat-box-wrapper {
          width: 100%;
        }
        .chat-box-inner {
          background-color: #bce6ff;
        }
      }
      &.remake {
        .avatar-icon-wrapper,
        .reply,
        small {
          display: none !important;
        }
        .chat-box-wrapper {
          width: 100%;
        }
        .chat-box-inner {
          border: 1px solid #009cff;
          background: #e0f3ff;
        }
      }
      .chat-box-wrapper {
        display: block;
        padding: 0;
        word-break: break-word;
      }
      .chat-box-inner {
        background-color: #f0f2f5;
        border-radius: 18px;
        padding: 8px 15px;
      }

      .user-name {
        font-weight: bold;
        font-size: 13px;
      }

      .user-role,
      .date-created {
        font-size: 12px;
        color: #aaa;
        font-style: italic;
        margin-left: 5px;
      }
      .date-created-wrapper {
        font-size: 11px;
        color: #aaa;
      }
      p {
        margin: 0;
      }
      .message-imgs {
        display: flex;
        flex-wrap: wrap;
        img {
          border-radius: 10px;
          border: 1px solid #dfdfdf;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-top: 5px;
          margin-right: 5px;
        }
      }
      small {
        font-size: 12px;
        color: #65676b;
        a {
          color: inherit;
          text-decoration: none;
          font-weight: bold;
          padding-right: 5px;
        }
      }
    }
    .avatar-icon {
      margin-right: 5px;
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        border: 1px solid #dfdfdf;
      }
    }
  }
}
</style>
